import "./lastConnected-b964dc30.js";
import { W as p } from "./index-c4ef0430.js";
import "starknet";
import "./publicRcpNodes-be041588.js";
export {
  p as WebWalletConnector
};
